"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = Icon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _svg = require("./svg");

var _excluded = ["className", "icon", "size", "color", "testId"];
var styles = {
  "Icon": "Icon__Icon___38Epv",
  "Icon--tiny": "Icon__Icon--tiny___V4Pr9",
  "Icon--small": "Icon__Icon--small___1yGZK",
  "Icon--medium": "Icon__Icon--medium___3Pezi",
  "Icon--large": "Icon__Icon--large___215R6",
  "Icon--trimmed": "Icon__Icon--trimmed___1CmZL",
  "Icon--primary": "Icon__Icon--primary___3M4Il",
  "Icon--positive": "Icon__Icon--positive___1V4nP",
  "Icon--negative": "Icon__Icon--negative___1dled",
  "Icon--warning": "Icon__Icon--warning___39Bnz",
  "Icon--secondary": "Icon__Icon--secondary___1ztcw",
  "Icon--muted": "Icon__Icon--muted___3egnD",
  "Icon--white": "Icon__Icon--white___3GVPJ"
};
var iconComponents = {
  ArrowDown: _svg.ArrowDown,
  ArrowDownTrimmed: _svg.ArrowDownTrimmed,
  ArrowUp: _svg.ArrowUp,
  ArrowUpTrimmed: _svg.ArrowUpTrimmed,
  Asset: _svg.Asset,
  AssetTrimmed: _svg.AssetTrimmed,
  Calendar: _svg.Calendar,
  ChatBubble: _svg.ChatBubble,
  ChatBubbleTrimmed: _svg.ChatBubbleTrimmed,
  CheckCircle: _svg.CheckCircle,
  CheckCircleTrimmed: _svg.CheckCircleTrimmed,
  ChevronDown: _svg.ChevronDown,
  ChevronDownTrimmed: _svg.ChevronDownTrimmed,
  ChevronLeft: _svg.ChevronLeft,
  ChevronLeftTrimmed: _svg.ChevronLeftTrimmed,
  ChevronRight: _svg.ChevronRight,
  ChevronRightTrimmed: _svg.ChevronRightTrimmed,
  ChevronUp: _svg.ChevronUp,
  ChevronUpTrimmed: _svg.ChevronUpTrimmed,
  Clock: _svg.Clock,
  ClockTrimmed: _svg.ClockTrimmed,
  Close: _svg.Close,
  CloseTrimmed: _svg.CloseTrimmed,
  CloudUpload: _svg.CloudUpload,
  Code: _svg.Code,
  CodeTrimmed: _svg.CodeTrimmed,
  Copy: _svg.Copy,
  CopyTrimmed: _svg.CopyTrimmed,
  Cycle: _svg.Cycle,
  CycleTrimmed: _svg.CycleTrimmed,
  Delete: _svg.Delete,
  DeleteTrimmed: _svg.DeleteTrimmed,
  Done: _svg.Done,
  DoubleArrow: _svg.DoubleArrow,
  Download: _svg.Download,
  DownloadTrimmed: _svg.DownloadTrimmed,
  Drag: _svg.Drag,
  DragTrimmed: _svg.DragTrimmed,
  Edit: _svg.Edit,
  EditTrimmed: _svg.EditTrimmed,
  EmbeddedEntryBlock: _svg.EmbeddedEntryBlock,
  EmbeddedEntryBlockTrimmed: _svg.EmbeddedEntryBlockTrimmed,
  EmbeddedEntryInline: _svg.EmbeddedEntryInline,
  EmbeddedEntryInlineTrimmed: _svg.EmbeddedEntryInlineTrimmed,
  Entry: _svg.Entry,
  EntryTrimmed: _svg.EntryTrimmed,
  Environment: _svg.Environment,
  EnvironmentAlias: _svg.EnvironmentAlias,
  ErrorCircle: _svg.ErrorCircle,
  ErrorCircleOutline: _svg.ErrorCircleOutline,
  ErrorCircleTrimmed: _svg.ErrorCircleTrimmed,
  ExternalLink: _svg.ExternalLink,
  ExternalLinkTrimmed: _svg.ExternalLinkTrimmed,
  FaceHappy: _svg.FaceHappy,
  FaceHappyTrimmed: _svg.FaceHappyTrimmed,
  Filter: _svg.Filter,
  FilterTrimmed: _svg.FilterTrimmed,
  Folder: _svg.Folder,
  FolderCreate: _svg.FolderCreate,
  FolderCreateTrimmed: _svg.FolderCreateTrimmed,
  FolderOpen: _svg.FolderOpen,
  FolderOpenTrimmed: _svg.FolderOpenTrimmed,
  FolderTrimmed: _svg.FolderTrimmed,
  FormatBold: _svg.FormatBold,
  FormatBoldTrimmed: _svg.FormatBoldTrimmed,
  FormatItalic: _svg.FormatItalic,
  FormatItalicTrimmed: _svg.FormatItalicTrimmed,
  FormatUnderlined: _svg.FormatUnderlined,
  FormatUnderlinedTrimmed: _svg.FormatUnderlinedTrimmed,
  Gift: _svg.Gift,
  Heading: _svg.Heading,
  HeadingOne: _svg.HeadingOne,
  HeadingOneTrimmed: _svg.HeadingOneTrimmed,
  HeadingTrimmed: _svg.HeadingTrimmed,
  HeadingTwo: _svg.HeadingTwo,
  HeadingTwoTrimmed: _svg.HeadingTwoTrimmed,
  HelpCircle: _svg.HelpCircle,
  HelpCircleInverted: _svg.HelpCircleInverted,
  HelpCircleTrimmed: _svg.HelpCircleTrimmed,
  HorizontalRule: _svg.HorizontalRule,
  HorizontalRuleTrimmed: _svg.HorizontalRuleTrimmed,
  InfoCircle: _svg.InfoCircle,
  InfoCircleTrimmed: _svg.InfoCircleTrimmed,
  Language: _svg.Language,
  Link: _svg.Link,
  LinkAlternate: _svg.LinkAlternate,
  LinkTrimmed: _svg.LinkTrimmed,
  ListBulleted: _svg.ListBulleted,
  ListBulletedTrimmed: _svg.ListBulletedTrimmed,
  ListNumbered: _svg.ListNumbered,
  ListNumberedTrimmed: _svg.ListNumberedTrimmed,
  Lock: _svg.Lock,
  LockTrimmed: _svg.LockTrimmed,
  Logout: _svg.Logout,
  LooksOne: _svg.LooksOne,
  LooksOneTrimmed: _svg.LooksOneTrimmed,
  LooksTwo: _svg.LooksTwo,
  LooksTwoTrimmed: _svg.LooksTwoTrimmed,
  Menu: _svg.Menu,
  MenuTrimmed: _svg.MenuTrimmed,
  Minus: _svg.Minus,
  MoreHorizontal: _svg.MoreHorizontal,
  MoreHorizontalTrimmed: _svg.MoreHorizontalTrimmed,
  MoreVertical: _svg.MoreVertical,
  MoreVerticalTrimmed: _svg.MoreVerticalTrimmed,
  Person: _svg.Person,
  Plus: _svg.Plus,
  PlusCircle: _svg.PlusCircle,
  PlusCircleTrimmed: _svg.PlusCircleTrimmed,
  PlusTrimmed: _svg.PlusTrimmed,
  Preview: _svg.Preview,
  Puzzle: _svg.Puzzle,
  Quote: _svg.Quote,
  QuoteTrimmed: _svg.QuoteTrimmed,
  Receipt: _svg.Receipt,
  ReceiptTrimmed: _svg.ReceiptTrimmed,
  References: _svg.References,
  Release: _svg.Release,
  ReleaseTrimmed: _svg.ReleaseTrimmed,
  Search: _svg.Search,
  SearchTrimmed: _svg.SearchTrimmed,
  Settings: _svg.Settings,
  SettingsTrimmed: _svg.SettingsTrimmed,
  ShoppingCart: _svg.ShoppingCart,
  ShoppingCartTrimmed: _svg.ShoppingCartTrimmed,
  Star: _svg.Star,
  StarTrimmed: _svg.StarTrimmed,
  Subscript: _svg.Subscript,
  SubscriptTrimmed: _svg.SubscriptTrimmed,
  Superscript: _svg.Superscript,
  SuperscriptTrimmed: _svg.SuperscriptTrimmed,
  Tab: _svg.Tab,
  Table: _svg.Table,
  Tags: _svg.Tags,
  Text: _svg.Text,
  TextTrimmed: _svg.TextTrimmed,
  ThumbDown: _svg.ThumbDown,
  ThumbDownTrimmed: _svg.ThumbDownTrimmed,
  ThumbUp: _svg.ThumbUp,
  ThumbUpTrimmed: _svg.ThumbUpTrimmed,
  Users: _svg.Users,
  UsersTrimmed: _svg.UsersTrimmed,
  Warning: _svg.Warning,
  WarningTrimmed: _svg.WarningTrimmed,
  Workflows: _svg.Workflows
};

function Icon(_ref) {
  var _cn;

  var className = _ref.className,
      icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-icon' : _ref$testId,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(styles.Icon, (_cn = {}, (0, _defineProperty2["default"])(_cn, styles["Icon--".concat(size)], size), (0, _defineProperty2["default"])(_cn, styles["Icon--".concat(color)], color), (0, _defineProperty2["default"])(_cn, styles['Icon--trimmed'], icon.toLowerCase().includes('trimmed')), _cn), className);
  var Element = iconComponents[icon];
  return /*#__PURE__*/_react["default"].createElement(Element, (0, _extends2["default"])({
    "data-test-id": testId,
    className: classNames
  }, otherProps));
}